import React from "react";
import { ReactComponent as TrashIcon } from "../assets/icons/trash-01.svg";
import { ReactComponent as PenIcon } from "../assets/icons/edit.svg";
export default function CardBasic({
  i,
  data,
  children,
  title,
  isDisable,
  enActionDelete,
  enActionEdit,
  deleteFunction,
  editFunction,
  onClickCustomFunction,
  balanceCard,
  customButton,
  information,
  subtitle,
}) {
  return (
    <div
      className="relative w-full rounded-lg border border-gray-200 bg-white shadow-sm"
      onClick={onClickCustomFunction}
    >
      <div className="px-3 py-3">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-semibold text-gray-700">{title}</div>
            {subtitle && (
              <div className="mt-2 text-xs text-monochrome-400">{subtitle}</div>
            )}
          </div>
        </div>
        {/* Information */}
        {!balanceCard && information && information}
        {balanceCard && children}
      </div>
      <div
        className={`rounded-t-lg bg-monochrome-25 ${!enActionEdit && !enActionDelete && !customButton ? "rounded-b-lg" : ""}`}
      >
        {balanceCard && information ? information : children}
      </div>
      {enActionEdit || enActionDelete || customButton ? (
        <div className="bg-monochrome-25">
          <div className="rounded-lg bg-monochrome-50">
            <div className="flex justify-between p-3">
              {customButton && customButton}
              {enActionDelete && (
                <button
                  onClick={() => deleteFunction(i, data)}
                  disabled={isDisable}
                  className="flex items-center justify-center gap-2 rounded-lg border border-monochrome-100 bg-white px-3 py-1.5  text-xs font-semibold text-monochrome-600 transition-colors disabled:bg-monochrome-50 disabled:text-monochrome-300"
                >
                  <TrashIcon />
                  Hapus
                </button>
              )}
              {enActionEdit && (
                <button
                  disabled={isDisable}
                  onClick={() => editFunction(data)}
                  className="flex items-center justify-center gap-2 rounded-lg border border-monochrome-100 bg-white px-3 py-1.5  text-xs font-semibold text-monochrome-600 transition-colors disabled:bg-monochrome-50 disabled:text-monochrome-300"
                >
                  <PenIcon />
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
